import { useEffect } from 'react';

/**
 * SeoHead – ustawia dynamiczne meta tagi dla podstron
 * Używaj na każdej podstronie produktowej / kolekcji
 */
export default function SeoHead({ title, description, image, canonical }) {
  useEffect(() => {
    // Title
    if (title) document.title = title;

    const setMeta = (selector, attr, value) => {
      if (!value) return;
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement('meta');
        const [attrName, attrVal] = selector.match(/\[([^\]]+)="([^"]+)"\]/).slice(1);
        el.setAttribute(attrName, attrVal);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    if (image) setMeta('meta[property="og:image"]', 'content', image);
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (link) link.setAttribute('href', canonical);
    }

    return () => {
      // Przywróć domyślne przy odmontowaniu
      document.title = 'LYKKE NOMAD – Premium badstuer | Nordisk arkitektur, Oslo';
      const desc = document.querySelector('meta[name="description"]');
      if (desc) desc.setAttribute('content', 'Vi designer og bygger premium badstuer med nordisk arkitektur. Skreddersydde utendørsbadstuer levert over hele Norge. Konfigurator, priser og inspirasjon på lykke.info.');
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) ogTitle.setAttribute('content', 'LYKKE NOMAD – Premium badstuer | Nordisk arkitektur');
      const ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) ogDesc.setAttribute('content', 'Vi designer og bygger premium badstuer med nordisk arkitektur. Skreddersydde utendørsbadstuer levert over hele Norge.');
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) canonical.setAttribute('href', 'https://lykke.info/');
    };
  }, [title, description, image, canonical]);

  return null;
}